import { useDocumentTitle } from '@/hooks/useDocumentTitle';
import { useNavigate } from '@tanstack/react-router';
import { showSuccessToast } from '@/features/agent/job_change_processes/lib/toast';
import CandidateProfileAddForm from '../components/CandidateProfileAddForm';

type Props = {
  /** true の場合、フォーム上部に書類アップロードセクションを表示する */
  showResumeUpload?: boolean;
};

export function CandidatesNewTemplate({ showResumeUpload = false }: Props) {
  useDocumentTitle('求職者を追加');
  const navigate = useNavigate();

  const handleSuccess = (createdId: number) => {
    showSuccessToast('求職者を作成しました');
    navigate({
      to: '/agent/candidates/$candidateProfileId',
      params: { candidateProfileId: String(createdId) },
    });
  };

  return <CandidateProfileAddForm onSuccess={handleSuccess} showResumeUpload={showResumeUpload} />;
}
